import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../../components/Navbar';
import PageTitle from '../../components/pagetitle';
import Scrollbar from '../../components/scrollbar';
import { useParams } from 'react-router-dom';
import RelatedProject from './related';
import Discuss from './discuss';
import Logo from '../../images/logo.svg';
import Footer from '../../components/footer';
import { fetchProject } from '../../api/api';
import { queryClient, useFetch } from '../../hooks/useFetch';

const ProjectSinglePage = (props) => {
    const { t } = useTranslation(); // Use translation hook
    const { id } = useParams();

    const { data: projectDetails, isLoading, error } = useFetch(["project", id], (lang) => fetchProject(lang, id));
    const projects = queryClient.getQueryData(["projects"])?.data?.data;

    return (
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle
                pageTitle={projectDetails?.data?.data?.data?.title || t('project.defaultTitle')}
                pagesub={t('project.subtitle')}
            />
            {isLoading ? (
                <>{t('loading')}</>
            ) : error ? (
                <>{t('error')}</>
            ) : (
                <div className="wpo-project-single-area section-padding">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-12">
                                <div className="wpo-project-single-wrap">
                                    <div className="wpo-project-single-item">
                                        <div className="row align-items-center">
                                            <div className="col-lg-7">
                                                <div className="wpo-project-single-title">
                                                    <h3>
                                                        {projectDetails?.data?.data?.data?.title}{' '}
                                                        {t('project.subtitle')}
                                                    </h3>
                                                </div>
                                                <p>{projectDetails?.data?.data?.data?.description}</p>
                                            </div>
                                            <div className="col-lg-5">
                                                <div className="wpo-project-single-content-des-right">
                                                    <ul>
                                                        <li>
                                                            {t('project.location')} :{' '}
                                                            <span>{projectDetails?.data?.data?.data?.location}</span>
                                                        </li>
                                                        <li>
                                                            {t('project.client')} :{' '}
                                                            <span>{projectDetails?.data?.data?.data?.client}</span>
                                                        </li>
                                                        <li>
                                                            {t('project.architect')} :{' '}
                                                            <span>{projectDetails?.data?.data?.data?.Architect}</span>
                                                        </li>
                                                        <li>
                                                            {t('project.projectType')} :{' '}
                                                            <span>{projectDetails?.data?.data?.data?.projectType}</span>
                                                        </li>
                                                        <li>
                                                            {t('project.duration')} :{' '}
                                                            <span>{projectDetails?.data?.data?.data?.duration}</span>
                                                        </li>
                                                        <li>
                                                            {t('project.completion')} :{' '}
                                                            <span>{projectDetails?.data?.data?.data?.complition}</span>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wpo-project-single-main-img">
                                            <img
                                                src={`${process.env.REACT_APP_API_URL}/api/images/${projectDetails?.data?.data?.data?.thumbnail}`}
                                                alt=""
                                            />
                                        </div>
                                        <div className="wpo-project-single-item list-widget">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="wpo-project-single-title">
                                                        <h3>{t('project.strategies')}</h3>
                                                    </div>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: projectDetails?.data?.data?.data?.strategies,
                                                        }}
                                                    ></div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="wpo-project-single-item-quote">
                                                        <p>
                                                            {t('project.quote.text')}
                                                        </p>
                                                        <span>
                                                            {t('project.quote.author')} -{' '}
                                                            <span>{t('project.quote.theme')}</span>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wpo-project-single-item">
                                            <div className="wpo-project-single-title">
                                                <h3>{t('project.approach')}</h3>
                                            </div>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: projectDetails?.data?.data?.data?.approach,
                                                }}
                                            ></div>
                                        </div>
                                        <div className="wpo-project-single-gallery">
                                            <div className="row mt-4">
                                                <div className="col-md-6 col-sm-6 col-12">
                                                    <div className="wpo-p-details-img">
                                                        <img
                                                            src={`${process.env.REACT_APP_API_URL}/api/images/${projectDetails?.data?.data?.data?.goalsImage}`}
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-md-6 col-sm-6 col-12">
                                                    <div className="wpo-p-details-img">
                                                        <img
                                                            src={`${process.env.REACT_APP_API_URL}/api/images/${projectDetails?.data?.data?.data?.resultsImage}`}
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="wpo-project-single-item list-widget">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="wpo-project-single-title">
                                                        <h3>{t('project.goalsReceived')}</h3>
                                                    </div>
                                                    <ul>
                                                        {projectDetails?.data?.data?.data?.goals?.map((item, i) => (
                                                            <li key={i}>{item}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                <div className="col-lg-6 list-widget-s">
                                                    <div className="wpo-project-single-title">
                                                        <h3>{t('project.results')}</h3>
                                                    </div>
                                                    <ul>
                                                        {projectDetails?.data?.data?.data?.results?.map((item, i) => (
                                                            <li key={i}>{item}</li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <RelatedProject projects={projects} currentId={projectDetails?.data?.slug} />
                                        <Discuss />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <Footer ftClass={'wpo-site-footer-s2'} />
            <Scrollbar />
        </Fragment>
    );
};

export default ProjectSinglePage;
